export const portalRoles = [
  "administrator",
  "scientific-reviewer",
  "submitter",
] as const;

export type PortalRole = (typeof portalRoles)[number];

export const profileStatuses = [
  "pending",
  "approved",
  "suspended",
] as const;

export const submissionStatuses = [
  "submitted",
  "in-review",
  "changes-requested",
  "approved",
  "rejected",
  "published",
] as const;

export type SubmissionStatus = (typeof submissionStatuses)[number];

export const submissionTransitions: Record<
  SubmissionStatus,
  SubmissionStatus[]
> = {
  submitted: ["in-review", "changes-requested", "rejected"],
  "in-review": ["changes-requested", "approved", "rejected"],
  "changes-requested": ["submitted", "in-review", "rejected"],
  approved: ["published", "in-review"],
  rejected: ["submitted"],
  published: ["in-review"],
};

export const sourceEndpoints = [
  {
    sourceId: "prjeb41744",
    kind: "paper",
    url: "https://doi.org/10.1038/s41467-021-25607-2",
  },
  {
    sourceId: "prjeb41744",
    kind: "repository",
    url: "https://www.ebi.ac.uk/ena/browser/view/PRJEB41744",
  },
  {
    sourceId: "prjeb41744",
    kind: "processed",
    url: "https://zenodo.org/records/5163554",
  },
  {
    sourceId: "prjeb41744",
    kind: "author-atlas",
    url: "https://cellatlas-cxg.mvls.gla.ac.uk/view/Tbrucei.h5ad/",
  },
  {
    sourceId: "erp132258",
    kind: "paper",
    url: "https://doi.org/10.1371/journal.ppat.1010346",
  },
  {
    sourceId: "erp132258",
    kind: "repository",
    url: "https://www.ebi.ac.uk/ena/browser/view/ERP132258",
  },
  {
    sourceId: "erp132258",
    kind: "processed",
    url: "https://zenodo.org/records/6047732",
  },
  {
    sourceId: "prjeb58781",
    kind: "paper",
    url: "https://doi.org/10.7554/eLife.86325",
  },
  {
    sourceId: "prjeb58781",
    kind: "repository",
    url: "https://www.ebi.ac.uk/ena/browser/view/PRJEB58781",
  },
  {
    sourceId: "prjeb58781",
    kind: "processed",
    url: "https://zenodo.org/records/7508131",
  },
  {
    sourceId: "prjeb58781",
    kind: "author-atlas-bsf",
    url: "https://cellatlas-cxg.mvls.gla.ac.uk/view/bsf.h5ad/",
  },
  {
    sourceId: "prjeb58781",
    kind: "author-atlas-pcf",
    url: "https://cellatlas-cxg.mvls.gla.ac.uk/view/pcf.h5ad/",
  },
  {
    sourceId: "gse174198",
    kind: "paper",
    url: "https://doi.org/10.1038/s41467-023-43437-2",
  },
  {
    sourceId: "gse174198",
    kind: "repository",
    url: "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE174198",
  },
  {
    sourceId: "gse174198",
    kind: "processed",
    url: "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE174198",
  },
  {
    sourceId: "e-mtab-14406",
    kind: "paper",
    url: "https://doi.org/10.1038/s41467-026-73098-w",
  },
  {
    sourceId: "e-mtab-14406",
    kind: "repository",
    url: "https://www.ebi.ac.uk/biostudies/arrayexpress/studies/E-MTAB-14406",
  },
  {
    sourceId: "e-mtab-14406",
    kind: "processed",
    url: "https://cellatlas-cxg.mvls.gla.ac.uk/view/Trypanosoma_cruzi_inVitro_cellatlas.h5ad/",
  },
  {
    sourceId: "prjna1200704",
    kind: "paper",
    url: "https://doi.org/10.7554/eLife.105822",
  },
  {
    sourceId: "prjna1200704",
    kind: "repository",
    url: "https://www.ncbi.nlm.nih.gov/bioproject/PRJNA1200704",
  },
  {
    sourceId: "prjna1200704",
    kind: "processed",
    url: "https://zenodo.org/records/18760090",
  },
] as const;

export const supportedSubmissionSpecies = [
  "Trypanosoma brucei brucei",
  "Trypanosoma brucei gambiense",
  "Trypanosoma brucei rhodesiense",
  "Trypanosoma congolense",
  "Trypanosoma vivax",
  "Trypanosoma evansi",
  "Trypanosoma equiperdum",
  "Trypanosoma cruzi",
  "Trypanosoma rangeli",
  "Other Trypanosoma",
] as const;
